<template>
  <div class="component_card">
    <div class="column">
      <h1 class="text_lg p0 tal_c">
        <strong>{{$t("msg.internal_transfer")}}</strong>
      </h1>
    </div>
    <div class="column columns redeem_form mw100">
      <div class="column mw100">
        <div class="column">
          <div class="column display_values_redeem">
            <p>{{$t("msg.total")}}:</p>
            <p>{{whithdraw.amount}} BLU</p>
          </div>
          <div class="column display_btc_adress_redeem tal_c" style="border:none;">
            <p>{{$t("msg.destination_user")}}:</p>
            <p class="fat word_break_word">{{whithdraw.address}}</p>
          </div>
          <div class="column">
            <button
              class="btn_redeem"
              style="width:100%;"
              @click="callNextStep()"
            >{{$t("msg.next_step")}}</button>
            <button
              class="btn_redeem_back"
              style="background:#e12d2d; width:100%;"
              @click="callBackStep()"
            >{{$t("msg.back")}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  props: ["whithdraw"],
  created() {
      console.log(this.whithdraw)
  },
  mounted() {},
  data: () => ({
    feeRedeem: ""
  }),
  components: {},
  methods: {
    callNextStep() {
      this.$emit("callNext");
    },

    callBackStep() {
      this.$emit("callBackStep");
    },
  },
  computed: {
    ...mapGetters([
      "member",
      "currencies",
      "bluAccount",
      "btcAccount",
      "bluValue",
      "btcValue"
    ])
  },
  watch: {}
};
</script>




// WEBPACK FOOTER //
// src/components/private/services/internal_steps/internalStepConfirm.vue